import React, {useMemo, memo} from 'react';
import {Props} from './ac-avatar-card.proptypes';
import clsx from 'clsx';

// Imports => Constants
import {TYPES} from '@asdf-constants';

// Imports => Utilities
import {AcIsObject} from '@asdf-utils';

// Imports => Atoms
import {AcHeading} from '@asdf-atoms/ac-heading';
import {AcAvatar} from '@asdf-atoms/ac-avatar';

const _CLASSES = {
  MAIN: 'ac-avatar-card',
  THEME: {
    DEFAULT: 'ac-avatar-card--default',
    OMEGA: 'ac-avatar-card--omega',
    ALPHA: 'ac-avatar-card--alpha',
    BETA: 'ac-avatar-card--beta',
    CHARLIE: 'ac-avatar-card--charlie',
    ECHO: 'ac-avatar-card--echo',
  },
  TITLE: 'ac-avatar-card__title',
  SUBTITLE: 'ac-avatar-card__subtitle',
};

const AcAvatarCard = memo(
  ({avatar = null, title, subtitle, theme = 'default', className, children, ...rest}) => {
    const getSubtitleClassNames = useMemo(() => {
      return clsx(_CLASSES.SUBTITLE);
    }, []);

    const getTitleClassNames = useMemo(() => {
      return clsx(_CLASSES.TITLE);
    }, []);

    const getMainClassNames = useMemo(() => {
      return clsx(_CLASSES.MAIN, theme && _CLASSES.THEME[theme.toUpperCase()], className);
    }, [className, theme]);

    const renderAvatar = useMemo(() => {
      if (!AcIsObject(avatar)) return null;

      return <AcAvatar avatar={avatar} />;
    }, [avatar]);

    return (
      <div className={getMainClassNames} {...rest}>
        {renderAvatar}

        {title && (
          <AcHeading rank={4} className={getTitleClassNames}>
            {title}
          </AcHeading>
        )}

        {subtitle && (
          <p
            className={getSubtitleClassNames}
            dangerouslySetInnerHTML={{
              __html: subtitle,
            }}
          />
        )}

        {children}
      </div>
    );
  }
);

AcAvatarCard.displayName = 'AcAvatarCard';
AcAvatarCard.propTypes = Props;

export {AcAvatarCard};
export default AcAvatarCard;
